import { Routes } from '@angular/router';
import { HomePageComponent } from './pages/home/home-page.component';
import { NewsArticlePageComponent } from './pages/news/article-page/news-article-page.component';
import { NewsPageComponent } from './pages/news/news-page.component';

export const routes: Routes = [
  { path: '', component: HomePageComponent },
  { path: 'news', component: NewsPageComponent },
  { path: 'news/:slug', component: NewsArticlePageComponent },
  // Mindig utolsó: a wildcard mindent elkap, ami fölötte nem illeszkedett.
  { path: '**', redirectTo: '' }
];
